
  import React from "react"
  import Component from "/Users/mroth/projects/mroth.io/mroth.io/src/layouts/index.tsx"
  import data from "/Users/mroth/projects/mroth.io/mroth.io/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js